import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "./AdminLayout";

/** Keep every admin page under one persistent shell instead of remounting per route partial. */
export function coalesceAdminLayoutRoutes(
  routes: readonly RouteObject[],
): RouteObject[] {
  const adminRoutes = routes.filter(isAdminLayoutRoute);
  if (adminRoutes.length < 2) return [...routes];
  adminRoutes.forEach(requireMergeableAdminRoute);
  const children = adminRoutes.flatMap((route) => route.children ?? []);
  let inserted = false;
  return routes.flatMap((route) => {
    if (!isAdminLayoutRoute(route)) return [route];
    if (inserted) return [];
    inserted = true;
    return [{ Component: AdminLayout, children }];
  });
}

function isAdminLayoutRoute(route: RouteObject): boolean {
  return route.Component === AdminLayout;
}

function requireMergeableAdminRoute(route: RouteObject): void {
  const unsupported = Object.keys(route).filter((key) =>
    isUnsupportedAdminRouteKey(key),
  );
  if (unsupported.length === 0) return;
  throw new Error(
    `AdminLayout route keys=${unsupported.join(",")} expected only Component and children`,
  );
}

function isUnsupportedAdminRouteKey(key: string): boolean {
  return key !== "Component" && key !== "children";
}
